import {
  EMPLOYEES_SET_LOADING,
  EMPLOYEES_SET_ERROR,
  EMPLOYEES_SET_EMPLOYEE,
  EMPLOYEES_FETCH_EMPLOYEE,
  EMPLOYEES_CLEAR_ERROR,
  EMPLOYEES_GET_EMPLOYEE,
  EMPLOYEES_GET_LOADING,
  EMPLOYEES_GET_ERROR
} from './types';
import { employeeService } from '@/network';
import {
  handleAsyncAction,
  createAsyncState,
  createAsyncMutations
} from '@/utils/helpers/store';

const state = {
  employee: {},
  ...createAsyncState(['fetchEmployee'])
};

const mutations = {
  ...createAsyncMutations(EMPLOYEES_SET_LOADING, EMPLOYEES_SET_ERROR),
  [EMPLOYEES_SET_EMPLOYEE](state, employee) {
    state.employee = employee;
  }
};

const actions = {
  async [EMPLOYEES_FETCH_EMPLOYEE]({ commit }, { rut }) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchEmployee',
      errorMessage: 'Ocurrió un error al obtener el empleado',
      asyncOperation: async () => {
        const employee = await employeeService.getEmployee({
          rut
        });
        commit(EMPLOYEES_SET_EMPLOYEE, employee);
        return employee;
      },
      setLoading: EMPLOYEES_SET_LOADING,
      setError: EMPLOYEES_SET_ERROR
    });
  },

  [EMPLOYEES_CLEAR_ERROR]({ commit }, { type }) {
    commit(EMPLOYEES_SET_ERROR, {
      type,
      value: null
    });
  }
};

const getters = {
  [EMPLOYEES_GET_EMPLOYEE]: (state) => state.employee,
  [EMPLOYEES_GET_LOADING]: (state) => state.loading,
  [EMPLOYEES_GET_ERROR]: (state) => state.error
};

export default {
  state,
  mutations,
  actions,
  getters
};
